/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-16T17:00:11.37
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getEvaluateAppointmentFinalEditInit,
	getEvaluateAppointmentFinalView
} from '@api/storagemanage/EvaluateAppointmentFinal';

import {
listEvaluateAppointmentFinalRejectionInit,
listEvaluateAppointmentFinalRejectionByAuthorizations,
deleteEvaluateAppointmentFinalRejection
} from '@api/storagemanage/EvaluateAppointmentFinalRejection';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getEvaluateAppointmentFinalEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentFinalEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEvaluateAppointmentFinalView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentFinalView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
